
























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { MyjbiGroupType } from '@/jbi-shared/types/myjbi-group.types';
import TableActionDropdown from '@/components/TableActionDropdown.vue';
import { JbicGroupListColumns } from '@/store/modules/admin/types/group.types';
import { checkJbicPermission } from '@/utils/rbac.util';
import { JbicPermissions } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';

@Component({
  components: { TableActionDropdown },
  name: 'GroupRow'
})
export default class GroupRow extends Vue {
  @Prop(Object) public group!: JbicGroupListColumns;
  @Prop(Function) public getChildren!: (
    group: JbicGroupListColumns
  ) => JbicGroupListColumns[];
  @Prop({ type: Number, default: 1 }) public level!: number;
  @Prop(Boolean) public expandGroupFilter!: boolean;

  expanded = false;

  get descendants() {
    return this.getChildren(this.group);
  }

  get noSubGroup() {
    return !this.descendants.length;
  }

  get MyjbiGroupType() {
    return MyjbiGroupType;
  }

  get toShowCountBadge(): boolean {
    return (
      (this.isJbicEventManageRole || this.isJbicImageManageRole) &&
      this.group.pendingApprovalCount > 0
    );
  }

  get isJbicEventManageRole(): boolean {
    return checkJbicPermission(JbicPermissions.EVENT_MANAGE);
  }

  get isJbicImageManageRole(): boolean {
    return checkJbicPermission(JbicPermissions.IMAGE_MANAGE);
  }

  @Watch('expandGroupFilter', { immediate: true })
  private onOpenGroupsExpandedChanged() {
    this.expanded = this.expandGroupFilter;
  }
}
